
export function mergeRecursive(
  defaults: any,
  source: any,
  moveNulls: boolean = true
) {
  for (var p in source) {
    try {
      // Property in destination object set; update its value.
      if (source[p].constructor === Object) {
        defaults[p] = mergeRecursive(defaults[p], source[p], moveNulls);
      } else {
        defaults[p] = source[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      if (moveNulls) {
        defaults[p] = source[p];
      }
    }
  }

  return defaults;
}